import React, { useState, useEffect } from 'react';
import { Building2, Target, Users, Zap, Shield, Loader } from 'lucide-react';
import { getPageBySlug } from '../lib/pageService';

const Hakkimizda = () => {
  const [pageContent, setPageContent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        setIsLoading(true);
        const page = await getPageBySlug('hakkimizda');
        if (page && page.content) {
          setPageContent(page.content);
        } else {
          setError('Sayfa içeriği bulunamadı.');
        }
      } catch (err) {
        console.error('Error fetching page content:', err);
        setError('Sayfa içeriği yüklenirken bir hata oluştu.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPageContent();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex items-center gap-3">
          <Loader className="w-6 h-6 text-[#F7BA45] animate-spin" />
          <span className="text-slate-600">Sayfa yükleniyor...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-slate-50">
        <div className="bg-gradient-to-b from-[#F7BA45]/20 to-slate-50 py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6 text-center">
                Hakkımızda
              </h1>
              <div className="bg-white rounded-2xl p-8 shadow-xl border border-slate-200">
                <div className="text-center text-red-500">
                  <p>{error}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-gradient-to-b from-[#F7BA45]/20 to-slate-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6 text-center">
              Hakkımızda
            </h1>
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-slate-200">
              {pageContent ? (
                <div dangerouslySetInnerHTML={{ __html: pageContent }} />
              ) : (
                <div className="prose prose-slate max-w-none">
                  <div className="flex items-start gap-4 mb-8">
                    <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                      <Building2 className="w-6 h-6 text-[#F7BA45]" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-semibold text-slate-800 mb-4">Kredipark Nedir?</h2>
                      <p className="text-slate-600 leading-relaxed">
                        Kredipark.com, bankacılık ürünleri karşılaştırma platformudur.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 mb-8">
                    <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                      <Target className="w-6 h-6 text-[#F7BA45]" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-semibold text-slate-800 mb-4">Amacımız</h2>
                      <p className="text-slate-600 leading-relaxed">
                        Kredipark.com'un ana amacı ziyaretçiye en uygun maliyeti olan finansal ürünü, en hızlı şekilde sunarak tasarruf etmesini sağlamaktır.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 mb-8">
                    <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                      <Users className="w-6 h-6 text-[#F7BA45]" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-semibold text-slate-800 mb-4">Hizmetlerimiz</h2>
                      <p className="text-slate-600 leading-relaxed">
                        Kredipark çatısı altında kredi kartı, kredi, mevduat, banka hesap açılışı gibi banka ürünleri müşteri odaklı yaklaşım doğrultusunda birbiri ile karşılaştırılır.
                      </p>
                      <p className="text-slate-600 leading-relaxed mt-4">
                        Karşılaştırma işlemi sonucunda ziyaretçi çeşitli bankaların sunduğu finansal ürünler arasından kendisine en uygun seçimi yaparak başvuru işlemini gerçekleştirir.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                      <Shield className="w-6 h-6 text-[#F7BA45]" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-semibold text-slate-800 mb-4">Avantajlar</h2>
                      <p className="text-slate-600 leading-relaxed">
                        Ziyaretçi Kredipark.com aracılığı ile tüm banka ürünlerini tek bir çatı platform altında karşılaştırma kolaylığına ücretsiz erişim sağlar.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hakkimizda;